import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["PageLayout"] */ "/app/src/layouts/PageLayout.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assests/svg/Dots.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assests/svg/nav/account-balance-wallet.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assests/svg/nav/analytics.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assests/svg/nav/contact_page.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assests/svg/nav/double-arrow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assests/svg/nav/home.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assests/svg/nav/logout.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assests/svg/nav/manage-accounts.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assests/svg/nav/more.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assests/svg/nav/settings.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assests/svg/nav/shopping-cart.svg");
;
import(/* webpackMode: "eager" */ "/app/src/view/Main/Main.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/view/NotFound/NotFound.module.scss");
